import React from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import home_bg from '../../../assets/estate1.jpg'

const HomeCarousel = () => {
	const settings = {
		dots: true,
		infinite: true,
		speed: 1500,
		slidesToShow: 1,
		arrows: false,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 9000,
		pauseOnHover: false,
	}

	return (
		<div>
			<Slider {...settings}>
				<div>
					<div
						style={{ backgroundImage: `url(${home_bg})` }}
						className='homepage_bg'
					>
						<div className='container'>
							<div
								className='jumbotron-classic-content'
								// style={{
								// 	display: 'flex',
								// 	flexDirection: 'column',
								// 	height: '60vh',
								// }}
							>
								<div className='wow-outer'>
									<div className='title-docor-text font-weight-bold title-decorated text-uppercase wow slideInLeft text-white'>
										Offering Diverse
									</div>
								</div>
								<h1 className='text-uppercase text-white font-weight-bold wow-outer'>
									<span className='wow slideInDown' data-wow-delay='.2s'>
										Properties
									</span>
								</h1>
								<p className='text-white wow-outer'>
									<span className='wow slideInDown' data-wow-delay='.35s'>
										inHouse provides you with lots of great properties
										throughout the USA so that you could easily choose your
										dream property.
									</span>
								</p>
								<div className='wow-outer button-outer'>
									<Link
										className='button button-md button-primary btn_showel button-winona wow slideInDown'
										to='/properties'
										data-wow-delay='.4s'
									>
										View Properties
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div
						style={{ backgroundImage: `url(${home_bg})` }}
						className='homepage_bg'
					>
						<div className='container'>
							<div className='jumbotron-classic-content'>
								<div className='wow-outer'>
									<div className='title-docor-text font-weight-bold title-decorated text-uppercase wow slideInLeft text-white'>
										Easily
									</div>
								</div>
								<h1 className='text-uppercase text-white font-weight-bold wow-outer'>
									<span className='wow slideInDown' data-wow-delay='.2s'>
										Rent &amp; Sale
									</span>
								</h1>
								<p className='text-white wow-outer'>
									<span className='wow slideInDown' data-wow-delay='.35s'>
										With the help of our services and property management
										solutions, you can rent or sell any house or apartment.
									</span>
								</p>
								<div className='wow-outer button-outer'>
									<Link
										className='button button-md button-primary btn_showel button-winona wow slideInDown'
										to='/about-us'
										data-wow-delay='.4s'
									>
										Read More
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div
						style={{ backgroundImage: `url(${home_bg})` }}
						className='homepage_bg'
					>
						<div className='container'>
							<div className='jumbotron-classic-content'>
								<div className='wow-outer'>
									<div className='title-docor-text font-weight-bold title-decorated text-uppercase wow slideInLeft text-white'>
										More Than 20 Years of
									</div>
								</div>
								<h1 className='text-uppercase text-white font-weight-bold wow-outer'>
									<span className='wow slideInDown' data-wow-delay='.2s'>
										Experience
									</span>
								</h1>
								<p className='text-white wow-outer'>
									<span className='wow slideInDown' data-wow-delay='.35s'>
										Founded in 1989, our company is a team of renowned property
										management and real estate experts always ready to help you.
									</span>
								</p>
								<div className='wow-outer button-outer'>
									<Link
										className='button button-md button-primary btn_showel button-winona wow slideInDown'
										to='/contact-us'
										data-wow-delay='.4s'
									>
										Contact Us
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Slider>
		</div>
	)
}

export default HomeCarousel
